import { BaseViewStore} from 'core/stores';
import { action, observable } from "mobx";

class FacilityOrderNewFlowUSIntakeFindAndDeleteConfirmationModalStore extends BaseViewStore {
	@observable accessor isLoading = false;
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.facilityOrderTemplates =  this.modalParams.data.facilityOrderTemplates;
    }

    @action.bound
    async deleteFacilityOrderTemplateItems() {
        this.isLoading = true;
        await this.modalParams.data.deleteItems();
        this.modalParams.close();
    }
}

export default FacilityOrderNewFlowUSIntakeFindAndDeleteConfirmationModalStore;
